<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        @click="open('add')"
      >添加</el-button>

      <el-button
        type="success"
        size="mini"
        
        @click="getList()"
      >刷新</el-button>
      <el-popconfirm title="确定删除吗？" @confirm="handleDel">
        <el-button
          slot="reference"
          type="danger"
          size="mini"
          
          style="margin-left: 10px"
        >删除</el-button>
      </el-popconfirm>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      size="mini"

      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="sn" label="序号" width="55" />
      <el-table-column prop="version" label="版本号" width="100" />
      <el-table-column prop="state" label="强制更新" width="100">
        <template slot-scope="scope">
          <span :style="scope.row.isForce ? 'color:#00c759' : 'color:red'">{{
            scope.row.isForce ? "是" : "否"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateInfo" label="应用更新信息" />
      <el-table-column prop="downUrl" label="下载链接" />
      <el-table-column label="创建时间">
        <template slot-scope="scope">{{ scope.row.createDate }}</template>
      </el-table-column>

      <el-table-column prop="address" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="open('edit', scope.row)"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNumber"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <!-- 弹窗 -->
    <el-dialog
      :title="this.active.id ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      width="50%"
      :close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="active" label-width="140px" size="mini">
        <el-form-item label="序号">
          <el-input v-model="active.sn" placeholder="请输入序号" />
        </el-form-item>
        <el-form-item label="版本号">
          <el-input v-model="active.version" placeholder="请输入版本号" />
        </el-form-item>
        <el-form-item label="强制更新">
          <el-switch v-model="active.isForce" size="mini" />
        </el-form-item>
        <el-form-item label="下载链接">
          <el-input v-model="active.downUrl" placeholder="请输入下载链接" />
        </el-form-item>
        <el-form-item label="更新信息">
        </el-form-item>
        <el-form-item label="英文" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfo" placeholder="请输入英文" />
        </el-form-item>
        <el-form-item label="西班牙语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoEs" placeholder="请输入西班牙语" />
        </el-form-item>
        <el-form-item label="法语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoFr" placeholder="请输入法语" />
        </el-form-item>
        <el-form-item label="德语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoDe" placeholder="请输入德语" />
        </el-form-item>
        <el-form-item label="葡萄牙语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoPt" placeholder="请输入葡萄牙语" />
        </el-form-item>
        <el-form-item label="土耳其语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoTr" placeholder="请输入土耳其语" />
        </el-form-item>
        <el-form-item label="希腊语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoGr" placeholder="请输入希腊语" />
        </el-form-item>
        <el-form-item label="阿拉伯语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoEg" placeholder="请输入阿拉伯语" />
        </el-form-item>
        <el-form-item label="意大利语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoIt" placeholder="请输入意大利语" />
        </el-form-item>
        <el-form-item label="波斯语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoIr" placeholder="请输入波斯语" />
        </el-form-item>
        <el-form-item label="荷兰语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoNl" placeholder="请输入荷兰语" />
        </el-form-item>
        <el-form-item label="印地语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoIn" placeholder="请输入印地语" />
        </el-form-item>
        <el-form-item label="乌兹别克语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoUz" placeholder="请输入乌兹别克语" />
        </el-form-item>
        <el-form-item label="越南语" style="margin-bottom: 8px;">
          <el-input v-model="active.updateInfoVn" placeholder="请输入越南语" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 10px"
          @click="dialogVisible = false"
        >取 消</el-button>
        <el-popconfirm v-if="!active.id" title="确定添加？" @confirm="add()">
          <el-button slot="reference" type="primary" class="edit-button">确 定</el-button>
        </el-popconfirm>
        <el-popconfirm v-else title="确定修改？" @confirm="edit()">
          <el-button slot="reference" type="primary" class="edit-button">确 定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
export default {
  name: 'UserAndroidVersion',
  components: { Pagination },
  data() {
    return {
      pageNumber: 1,
      pageSize: 20,
      loading: false,
      total: 0,
      wechat: '', // 微信号
      memo: '', // 备注
      isEnable: null, // 是否有效
      showtabelData: [], // 表单数据
      multipleSelection: [], // 选中项
      dialogVisible: false, // 弹窗标识
      active: {} // 选中项
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 筛选
    select() {
      this.pageNum = 1
      this.getList()
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.$api.androidVersion
        .getList(params)
        .then((res) => {
          this.showtabelData = res.records
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭添加弹窗
    handleClose() {
      // console.log(11)
      this.active = {}
    },
    open(type, item) {
      if (type == 'add') {
        this.active = {}
        this.active.isEnable = true
      } else if (type == 'edit') {
        this.active = JSON.parse(JSON.stringify(item))
        console.log(this.active)
        this.active.isForce ? this.active.isForce = true : this.active.isForce = 0
      }
      this.dialogVisible = true
    },
    // 删除选中项
    handleDel() {
      var ids = []
      if (this.multipleSelection.length === 0) {
        return this.$message.error('你还没有选中任何一项')
      }
      this.multipleSelection.forEach((item) => {
        ids.push(item.id)
      })
      var params = {
        ids: ids.toString()
      }
      this.$api.androidVersion
        .delList(params)
        .then((res) => {
          this.$message.success(res)
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.getList()
        })
    },
    // 添加
    add() {
      var params = {
        sn: this.active.sn,
        version: this.active.version,
        size: this.active.size,
        updateInfo: this.active.updateInfo,
        downUrl: this.active.downUrl,
        isForce: this.active.isForce ? 1 : 0,
        updateInfo: this.active.updateInfo,
        updateInfoEs: this.active.updateInfoEs,
        updateInfoFr: this.active.updateInfoFr,
        updateInfoDe: this.active.updateInfoDe,
        updateInfoPt: this.active.updateInfoPt,
        updateInfoTr: this.active.updateInfoTr,
        updateInfoGr: this.active.updateInfoGr,
        updateInfoEg: this.active.updateInfoEg,
        updateInfoIt: this.active.updateInfoIt,
        updateInfoIr: this.active.updateInfoIr,
        updateInfoNl: this.active.updateInfoNl,
        updateInfoIn: this.active.updateInfoIn,
        updateInfoUz: this.active.updateInfoUz,
        updateInfoVn: this.active.updateInfoVn
       
      }
      this.$api.androidVersion
        .addList(params)
        .then((res) => {
          this.$message.success(res)
          this.getList()
          this.dialogVisible = false
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 修改
    edit() {
      var params = {
        id: this.active.id,
        sn: this.active.sn,
        version: this.active.version,
        size: this.active.size,
        updateInfo: this.active.updateInfo,
        downUrl: this.active.downUrl,
        isForce: this.active.isForce ? 1 : 0,
        updateInfo: this.active.updateInfo,
        updateInfoEs: this.active.updateInfoEs,
        updateInfoFr: this.active.updateInfoFr,
        updateInfoDe: this.active.updateInfoDe,
        updateInfoPt: this.active.updateInfoPt,
        updateInfoTr: this.active.updateInfoTr,
        updateInfoGr: this.active.updateInfoGr,
        updateInfoEg: this.active.updateInfoEg,
        updateInfoIt: this.active.updateInfoIt,
        updateInfoIr: this.active.updateInfoIr,
        updateInfoNl: this.active.updateInfoNl,
        updateInfoIn: this.active.updateInfoIn,
        updateInfoUz: this.active.updateInfoUz,
        updateInfoVn: this.active.updateInfoVn
      }
      this.$api.androidVersion
        .editList(params)
        .then((res) => {
          this.$message.success(res)
          this.getList()
          this.dialogVisible = false
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    changeImages(e) {
    //   console.log(e);
      this.active.downUrl = e
    }
  }
}
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
  
}

</style>
